<template>
    <!-- This is a example of Validation with Childcomponent, can be used in other BaseEditPage Components -->
    <ValidationProvider 
            :name="field"
            :rules="rules"
            v-slot="{ errors }"
            slim
        >
        <v-text-field
            v-model="innerValue"
            :error-messages="errors"
            :label="label"
            :disabled="disabled"
            :suffix="suffix"
            :clearable="clearable"
            :type="type"
            depressed 
            :class="withMargin ? 'ml-4 mr-4' : ''" 
            :readonly="readonly"
            @click:clear="resetVal()"
            @focus="onNumberFieldFocus"
            @blur="onNumberFieldBlur"
            @input="additionalFunction()"
            :alvqa="alvqa"
            :maxlength="maxlength"
            :loading="loading"
        >
            <template v-slot:append>
                <BaseTooltip v-if="iconTooltipText !== ''">
                    <template v-slot:content><v-icon small color="grey" :alvqa="alvqa +'-icon-info'">fa-info-circle</v-icon></template>
                    <template v-slot:text><span>{{ iconTooltipText }}</span></template>
                </BaseTooltip>
            </template>
        </v-text-field>
    </ValidationProvider>
</template>

<script>
import VTextField from 'vuetify/es5/components/VTextField'
import BaseTooltip from '@/components/_base/BaseTooltip'

export default {
    name: "BaseEditPageTextField",
    extends: VTextField,
    components: {
        BaseTooltip
    },
    props: {
        context: String,
        field: String,
        required: Boolean,
        clearable:  {
            default: true
        },
        disabled:  {
            default: false
        },
        // For Validation
        rules: {
            type: [Object, String],
            default: ""
        },
        iconTooltipText: {
            type: String,
            default: ''
        },
        withMargin: {
            type: Boolean,
            default: true
        },
        additionalFunction: {
            type: Function,
            default: () => {}
        },
        alvqa: {
            type: String,
            default: ''
        },
        loading: {
            type: Boolean,
            default: false
        },
        maxlength: {
            type: [Number, String],
            default: null
        },
        formatAsInteger: {
            type: Boolean,
            default: false
        },
        numberFormat: {
            type: String,
            default: ''
        },
    },
    data() {
        return {
            isFocused: false
        }
    },
    computed: {
        innerValue: {
            get() { 
                const rawValue = this.$store.getters['get' + this.context + 'Details' + this.field]
                this.$i18n.locale
                // Only format if explicitly requested, readonly, and value exists
                if (this.formatAsInteger && this.readonly && rawValue != null && rawValue !== '') {
                    return this.$n(rawValue, 'numberInteger')
                }
                if (this.numberFormat && !this.isFocused && rawValue != null && rawValue !== '') {
                    return this.$alvPlugin.getNumberLocalization(rawValue, this.numberFormat)
                }
                return rawValue
            },
            set(value) {
                // Strip control characters (newlines, tabs, CR, other C0/C1 controls) from
                // single-line text fields. Pasted titles etc. can carry hidden line breaks that
                // corrupt fixed-width exports like CWR work registrations (ALVSERVICE-2454).
                if (typeof value === 'string') {
                    // Replace with a space (not remove) so words separated by a hidden line
                    // break do not get glued together, e.g. "You\nagain" -> "You again".
                    // eslint-disable-next-line no-control-regex
                    value = value.replace(/[\u0000-\u001F\u007F-\u009F]/g, ' ')
                }
                this.$store.commit('set'+ this.context + 'Details' + this.field, value)
            }
        }
    },
    methods: {
        onNumberFieldFocus() {
            if (!this.numberFormat) return
            this.isFocused = true
            const rawValue = this.$store.getters['get' + this.context + 'Details' + this.field]
            if (rawValue === null || rawValue === undefined || rawValue === '') return
            this.$store.commit(
                'set' + this.context + 'Details' + this.field,
                this.$alvPlugin.getNumberLocalization(rawValue, this.numberFormat)
            )
        },
        onNumberFieldBlur() {
            this.isFocused = false
            if (!this.numberFormat) return
            const rawValue = this.$store.getters['get' + this.context + 'Details' + this.field]
            if (rawValue === null || rawValue === undefined || rawValue === '') return
            this.$store.commit(
                'set' + this.context + 'Details' + this.field,
                this.$alvPlugin.getNumberLocalization(rawValue, this.numberFormat)
            )
        },
        async resetVal() {
            await this.$nextTick()
            this.innerValue = null
            this.additionalFunction()
        }
    }
}
</script>